
import { PuttSituation } from "@/types/golf";

export const shortPutts2m: PuttSituation = {
  id: 6,
  name: "Putts courts - 2 m",
  image: "/lovable-uploads/4e812018-3b5f-43a6-87df-f38b7526b006.png",
  description: "Sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ à 2m.\nPositionner 10 balles au point A et jouer successivement chaque balle.",
  distances: [
    { point: "A", distance: 2, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 2 },
    { condition: "Balle non rentrée", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 38 },
    { points: 2, index: 31 },
    { points: 4, index: 25 },
    { points: 6, index: 20 },
    { points: 8, index: 16 },
    { points: 10, index: 12 },
    { points: 12, index: 8 },
    { points: 14, index: 4 },
    { points: 16, index: 1 },
    { points: 18, index: -2 },
    { points: 20, index: -4 },
  ],
};
